<template>
	<div class="mt-2 caption font-italic text--secondary">
		<span :title="item.createdAt | toAbsoluteDate">
			{{ $t('FOOTER_INFO_CREATED', { createdBy, createdAt: toRelativeDate(item.createdAt) }) }}
		</span>
		<span v-if="item.createdAt !== item.updatedAt" :title="item.updatedAt | toAbsoluteDate">
			{{ $t(item.updatedBy ? 'FOOTER_INFO_UPDATED_OTHER' : 'FOOTER_INFO_UPDATED_SAME', {
				updatedBy: item.updatedByName,
				updatedAt: toRelativeDate(item.updatedAt)
			}) }}
		</span>
	</div>
</template>

<script>
import { toRelativeDate, toAbsoluteDate } from '@/utils/formatters';

export default {
	name: 'footer-info',
	props: {
		item: Object,
	},
	computed: {
		createdBy() {
			return this.item.createdByName || this.item.authorName;
		},
	},
	filters: {
		toAbsoluteDate,
	},
	methods: {
		toRelativeDate,
	},
}
</script>

<style>

</style>
